<template>
  <div id="teacher">
    <p><button type="button" @click="logout">Logout</button></p>
    <router-link to="createproject" tag="button" id="createProjButton">Create a New Project</router-link>
    <p id="existingProject">Use or Edit an Existing Project:</p>
    <ProjectList v-bind:project_items="project_items" v-on:edit-project="editProject" v-on:delete-project="deleteProject"/>
  </div>
</template>

<script>
import ProjectList from '@/components/ProjectList.vue'

export default {
  name: 'TeacherView',
  components: {
    ProjectList
  },
  data() {
    return {
      project_items: []
    }
  },
  created() {
    this.getProjects();
  },
  methods: {
    async getProjects() {
      let res = await fetch("/api/projects/", {
        credentials: 'include'
      });
      let jsonObj = (await res.json());

      if (!jsonObj.success) {
        if (jsonObj.error == "You're not logged in") {
          this.$router.push('/login');
        } else {
          alert(jsonObj.error);
        }
      } else {
        this.project_items = jsonObj.projects;
      }
    },
    editProject(uuid) {
      this.$router.push('/editproject/' + uuid.toString());
    },
    async deleteProject(id) {
      let url = "/api/deleteproject/" + id.toString();
      let res = await fetch(url, {
        method: 'POST',
        credentials: 'include'
      });
      let jsonObj = (await res.json());

      if (!jsonObj.success) {
        alert(jsonObj.error);
      } else {
        this.project_items = this.project_items.filter(function(x) {return x.id != id});
      }
    },
    async logout() {
      await fetch("/api/logout/", {
        method: 'POST',
        credentials: 'include'
      });
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
#teacher{
  width: 100%;
  display: inline-block;
}

#createProjButton{
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;
  margin-top: 10px;
  border: none;
  font-size: large;
}

#createProjButton{
  cursor: pointer;
}

#existingProject{
  font-weight: bold;
  font-size: large;
}

</style>
